import { useEffect, useState } from 'react';
import { Offcanvas, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as apiClient from 'api/apiClients';
import { useToast } from 'context/ToastContext';
import ESpinner from 'components/others/Spinner';
import SolarIcon from 'components/icons/SolarIcon';
import ClientContacts from '../ClientContacts';
import ClientInfoForm from './ClientInfoForm';
import ClientInfoMap from './ClientInfoMap';

interface OffClientInfoProps {
    clientId: number | null;
    setClientId: (clientId: number | null) => void;
}

const OffClientInfo = ({ clientId, setClientId }: OffClientInfoProps) => {
    const { t } = useTranslation(['Clients', 'common']);
    const { showToast } = useToast();
    const [client, setClient] = useState<any>(null);
    const [activeTab, setActiveTab] = useState('general');

    const fetchClient = async () => {
        if (!clientId) return;
        const resClient = await apiClient.getClientById(clientId);
        if (!resClient) {
            showToast(t('common:messError'), 'danger');
            return;
        }
        setClient(resClient);
    };

    const handleClose = () => {
        setClientId(null);
    };

    useEffect(() => {
        setActiveTab('general');
        if (clientId) fetchClient();
        else {
            setTimeout(() => {
                setClient(null);
            }, 300);
        }
    }, [clientId]);

    return (
        <Offcanvas show={clientId !== null} onHide={handleClose} placement="end">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('titleInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                {client ? (
                    <div className="off-client-tabs d-flex flex-column h-100">
                        <Tabs
                            variant="underline"
                            activeKey={activeTab}
                            onSelect={(tab) => tab && setActiveTab(tab)}
                            className="mb-0 invoice-tab border-bottom px-3"
                        >
                            <Tab
                                eventKey="general"
                                title={
                                    <>
                                        <SolarIcon name="info-circle" className="me-2 fs-14" />
                                        {t('tabGeneral')}
                                    </>
                                }
                            >
                                <div className="px-3 pt-3 pb-4 overflow-auto h-100">
                                    <ClientInfoForm setClient={setClient} fetchClient={fetchClient} client={client} />
                                    <ClientInfoMap
                                        clientAddress={client.clientAddress}
                                        clientLocationUrl={client.clientLocationUrl}
                                    />
                                </div>
                            </Tab>
                            <Tab
                                eventKey="contacts"
                                title={
                                    <>
                                        <SolarIcon name="person-vcard" className="me-2 fs-14" />
                                        {t('tabContacts')}
                                    </>
                                }
                            >
                                <div className="px-3 pt-3 pb-4 overflow-auto h-100">
                                    <ClientContacts clientId={client.ID} mode="view" />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                ) : (
                    <ESpinner />
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffClientInfo;
